/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Rephrase_ShortenInputs */

const en_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rephrase - Shorten`)
};

const fr_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformuler - Raccourcir`)
};

const de_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umformulieren - Verkürzen`)
};

const it_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riformulare - Accorciare`)
};

const ru_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перефразировать - Сократить`)
};

const es_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parafrasear - Acortar`)
};

const zh_cn2_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改写 - 缩短`)
};

const ja_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言い換え - 短縮`)
};

const hi_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वाक्य बदलें - संक्षिप्त करें`)
};

const pt_pt2_event_ad_rephrase_shorten = /** @type {(inputs: Event_Ad_Rephrase_ShortenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformule - Encurte`)
};

/**
* | output |
* | --- |
* | "Rephrase - Shorten" |
*
* @param {Event_Ad_Rephrase_ShortenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_shorten = /** @type {((inputs?: Event_Ad_Rephrase_ShortenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_ShortenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_rephrase_shorten(inputs)
	if (locale === "de") return de_event_ad_rephrase_shorten(inputs)
	if (locale === "it") return it_event_ad_rephrase_shorten(inputs)
	if (locale === "ru") return ru_event_ad_rephrase_shorten(inputs)
	if (locale === "es") return es_event_ad_rephrase_shorten(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_rephrase_shorten(inputs)
	if (locale === "ja") return ja_event_ad_rephrase_shorten(inputs)
	if (locale === "hi") return hi_event_ad_rephrase_shorten(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_rephrase_shorten(inputs)
	return en_event_ad_rephrase_shorten(inputs)
});